import * as React from 'react';
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { useTheme } from '@material-ui/core/styles';
import type { IJobDetail } from './JobInterfaces';

interface FiledOptionsProps {
  formValues: IJobDetail;
  setFormValues: (formValues: IJobDetail) => void;
  handleFieldOptionRemove: (fieldindex: number, fieldOptionIndex: number) => void;
  handleAddNewFieldOption: (fieldIndex: number) => void;
}

const FieldOptions: React.FC<FiledOptionsProps> = ({
  formValues: JobFormValues, setFormValues: setJobFormValues, handleFieldOptionRemove, handleAddNewFieldOption,
}) => {
  const theme = useTheme();

  return (
    <>
      {JobFormValues.jobFields?.map((field, fieldIndex) => (
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Box p={2}>
                <TextField
                  value={field.fieldName}
                  id={`field${fieldIndex}-key-input`}
                  required
                  label="Field"
                  variant="outlined"
                  type="string"
                  disabled={field?.fieldInUse}
                  fullWidth
                  onChange={(event) => {
                    const inputVal = event.target.value;
                    const tempOptionValues = JobFormValues.jobFields;
                    tempOptionValues[fieldIndex].fieldName = inputVal;
                    setJobFormValues({ ...JobFormValues, jobFields: tempOptionValues });
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={8}>
              {JobFormValues.jobFields[fieldIndex].fieldOptions?.map((fieldOption, fieldOptionIndex) => (
                <>
                  <Grid container item xs={8}>
                    <Grid item xs={11}>
                      <Box p={2}>
                        <TextField
                          value={fieldOption.name}
                          id={`fieldOption${fieldOptionIndex}-value-input`}
                          required
                          disabled={fieldOption.inUse}
                          label="Field Option"
                          variant="outlined"
                          type="string"
                          fullWidth
                          onChange={(event) => {
                            const inputVal = event.target.value;
                            const tempOptionValues = JobFormValues.jobFields;
                            tempOptionValues[fieldIndex].fieldOptions[fieldOptionIndex].name = inputVal;
                            setJobFormValues({ ...JobFormValues, jobFields: tempOptionValues });
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={1}>
                      {
                        !fieldOption.inUse && (
                          <Box pt={2}>
                            <Tooltip title="Remove Tag" placement="top">
                              <IconButton onClick={() => { handleFieldOptionRemove(fieldIndex, fieldOptionIndex); }} style={{ color: theme.palette.error.main, float: 'right' }} disabled={false}>
                                <RemoveCircleIcon fontSize="large" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )
                      }
                    </Grid>
                  </Grid>
                </>
              ))}
            </Grid>
            <Grid container>
              <Grid item xs={4}>
                <Box />
              </Grid>
              <Grid item xs={6}>
                <Box px={1} clone pb={10}>
                  <Button
                    variant="text"
                    color="primary"
                    onClick={() => { handleAddNewFieldOption(fieldIndex); }}
                    style={{ minWidth: '5.625rem', float: 'left' }}
                  >
                    <IconButton disableFocusRipple disabled disableRipple>
                      <AddCircleIcon style={{ color: theme.palette.success.main, float: 'right' }} fontSize="large" />
                    </IconButton>
                    {'ADD NEW FIELD OPTION'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
};

export default FieldOptions;
